import React from 'react';
import {SplitPane} from 'react-collapse-pane';
import Scanner from './Components/Scanner/Scanner';
import useApplicationData from './Hooks/useApplicationData';
import './App.css';

const App = () => {
  const [{groupCollection, groups, loadingGroups}, dispatch] =
    useApplicationData();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const {sideBySide} = params;
  const showSideBySide =
    document.getElementById('rb_scanner').getAttribute('data-side-by-side') ??
    sideBySide ??
    false;

  const reformatGroups =
    Object.keys(groupCollection || {}).length === 3
      ? groups.map((gr, index) => {
          if (index === 1) {
            return {
              group: groupCollection[gr?.group],
              child: groupCollection[groups[index + 1]?.group] ?? null,
            };
          }
          if (index !== 2) {
            return {group: groupCollection[gr?.group]};
          }
          return null;
        })
      : null;

  const scanners = Object.keys(groupCollection || {}).length
    ? reformatGroups?.length && !showSideBySide
      ? reformatGroups
          .filter((item) => item !== null)
          .map((group) => {
            if (group?.child) {
              return (
                <SplitPane
                  key={groupCollection[group?.group] ?? null}
                  split="horizontal"
                  collapse
                  minSize={0}
                  defaultSize={0}
                >
                  <div
                    className={`${
                      Object.keys(groupCollection || {}).length > 1
                        ? 'multi-screen-scanner scanner-group'
                        : ' scanner-group'
                    }`}
                    key={groupCollection[group?.group?.group] ?? null}
                  >
                    <Scanner
                      group={groupCollection[group?.group?.group] ?? null}
                      dispatch={dispatch}
                      multiScreen
                      hasChild
                    />
                  </div>
                  <div
                    className={`${
                      Object.keys(groupCollection || {}).length > 1
                        ? 'multi-screen-scanner scanner-group'
                        : ' scanner-group'
                    }`}
                    key={groupCollection[group?.child] ?? null}
                  >
                    <Scanner
                      group={groupCollection[group?.child?.group] ?? null}
                      dispatch={dispatch}
                      multiScreen
                      hasChild
                    />
                  </div>
                </SplitPane>
              );
            }
            return (
              <div
                className={`${
                  Object.keys(groupCollection || {}).length > 1
                    ? 'multi-screen-scanner scanner-group'
                    : ' scanner-group'
                }`}
                key={groupCollection[group?.group?.group] ?? null}
              >
                <Scanner
                  group={groupCollection[group?.group?.group] ?? null}
                  dispatch={dispatch}
                  multiScreen
                />
                <div className="clearfix" />
              </div>
            );
          })
      : groups.map((group) => (
          <div
            className={`${
              Object.keys(groupCollection || {}).length > 1
                ? 'multi-screen-scanner scanner-group'
                : ' scanner-group'
            }`}
            key={group}
          >
            <Scanner
              group={groupCollection[group.group] ?? null}
              dispatch={dispatch}
              multiScreen={Object.keys(groupCollection || {}).length > 1}
            />
            <div className="clearfix" />
          </div>
        ))
    : null;

  if (
    groupCollection &&
    Object.keys(groupCollection || {})?.length &&
    scanners &&
    scanners.length > 1 &&
    !loadingGroups
  ) {
    return (
      <SplitPane split="vertical" collapse minSize={0} defaultSize={0}>
        {scanners}
      </SplitPane>
    );
  }
  if (
    groupCollection &&
    Object.keys(groupCollection || {})?.length === 1 &&
    !loadingGroups &&
    scanners &&
    scanners.length === 1
  ) {
    return scanners;
  }

  if (!groups || !groups?.length) {
    return (
      <div className="flex items-center justify-center py-8">
        <h1 className="text-3xl">No Scanners Available</h1>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-8">
      <h1 className="text-3xl">Loading Scanner</h1>
    </div>
  );
};

export default App;
